import './App.css';
import { motion } from 'framer-motion';
import { fadeSlide } from './animations/animationConfigs';

import Header from "./components/Header";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import CursorCircle from "./components/CursorCircle";
import TopScroll from "./components/TopScroll";
const sections = [
    [Header,   0],
    [About,    0.2],
    [Skills,   0.4],
    [Projects, 0.6],
    [Contact,  0.8],
];

function App() {
    return (
        <div className="App">
            <CursorCircle />
            <TopScroll />
            {sections.map(([Component, delay]) => (
                <motion.div
                    key={Component.name}
                    initial="hidden"
                    animate="visible"
                    variants={fadeSlide}
                    transition={{ duration: 0.5, delay }}
                >
                    <Component />
                </motion.div>
            ))}
        </div>
    );
}

export default App;
